/**
 * Phase 50 Plan 09 — SLA Breach Dashboard API client.
 *
 * Typed wrapper around `GET /api/manager/sla-breach-dashboard?from=YYYY-MM-DD&to=YYYY-MM-DD`.
 * Backend contract from Plan 50-04 (slaBreachDashboardRoutes.ts + slaBreachService.ts).
 *
 * Auth: relies on the existing Bearer token that `apiGet` attaches. The route
 * preHandler chain (`authenticate, requireManagerOrPM`) at the backend rejects
 * anonymous / plain-user calls with 401/403 — handled upstream by the React
 * Router `<ManagerRoute>` guard.
 */
import { apiGet } from './client';

export interface SlaBreachRow {
  taskId: number;
  taskTitle: string;
  taskCode: string | null;
  projectId: number;
  projectName: string;
  tierId: number;
  tierName: string;
  tierOrderIndex: number;
  resolutionElapsedMs: number;
  resolutionTargetMinutes: number;
  overduePct: number;
  assigneeId: number | null;
  assigneeName: string | null;
  createdAt: string;
}

export interface SlaBreachResult {
  rows: SlaBreachRow[];
  from: string;
  to: string;
  scannedAt: string;
}

export interface FetchSlaBreachOptions {
  from: string;
  to: string;
}

export async function fetchSlaBreachDashboard(
  opts: FetchSlaBreachOptions,
): Promise<SlaBreachResult> {
  const params = new URLSearchParams({ from: opts.from, to: opts.to });
  const res = await apiGet<{ data: SlaBreachResult }>(
    `/manager/sla-breach-dashboard?${params.toString()}`,
  );
  return res.data;
}
